<template>
    <div class="prop-box">
        <el-form label-width="auto">
            <el-form-item label="底部tab">
                <el-radio-group v-model="obj.config.bottom_tab_style">
                    <el-radio label="text">文字</el-radio>
                    <el-radio label="icon">图片</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="内购">
                <el-radio-group v-model="obj.config.show_buy">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

export default {
    name: "GlobalProp",
    components: {
    },
    props: ['obj'],
    data() {
        return {

        }
    },
    mounted() {

    }

}
</script>

<style scoped lang="less">

</style>